import React, { createContext, PropsWithChildren, useContext } from 'react';
import { AccountInfoResult } from '@block-explorer/entities';
import { useCreateAccountsInfoGetter } from '../hooks';
import { buildRouterPath } from '../router/utils';
import { CONTRACT_PACKAGE_PATH } from '../router/paths';

export const accountDataContext = createContext<{
  getAccountInfo: <T>(publicKey: string) => T | null | undefined;
  getPublicKeyAccountHash: (accountHash: string) => string | null | undefined;
  getPublicKeyByURef: (uref: string) => string | null | undefined;
  getAccountInfoByHash: (hash: string) => AccountInfoResult | null | undefined;
  getContractPackagePath: (hash: string) => string | null;
}>({
  getAccountInfo: () => null,
  getPublicKeyAccountHash: () => null,
  getPublicKeyByURef: () => null,
  getAccountInfoByHash: () => null,
  getContractPackagePath: () => null,
});

const { Provider: AccountDataContextProvider } = accountDataContext;

export const useAccountInfoContext = () => {
  return useContext(accountDataContext);
};

interface AccountDataContextProviderProps {
  accountAndPurseHashes: string[];
}
export const AccountDataProvider = (
  props: PropsWithChildren<AccountDataContextProviderProps>
) => {
  const { accountAndPurseHashes } = props;

  const {
    getAccountInfo,
    getAccountInfoByHash,
    getPublicKeyAccountHash,
    getPublicKeyByURef,
  } = useCreateAccountsInfoGetter(accountAndPurseHashes);

  const getContractPackagePath = (contractPackageHash) =>
    buildRouterPath(
      CONTRACT_PACKAGE_PATH,
      { id: contractPackageHash },
      undefined
    );

  return (
    <AccountDataContextProvider
      value={{
        getAccountInfo,
        getAccountInfoByHash,
        getPublicKeyAccountHash,
        getPublicKeyByURef,
        getContractPackagePath,
      }}
      {...props}
    />
  );
};
